import React, { useEffect, useState } from 'react';
import { Col, Label, Row } from 'reactstrap';
import CustomDatePickerV2 from 'views/pages/manage/common/commonComponents/CustomDatePicker-V2';
import { customStyle, getSwapLabelValue, inputAmountStyle, labelSyle, numberDecimalLimitRegex, 
    // validatePaymentMode 
} from '../../components/constant';
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput';
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import { ReactComponent as Scanner } from "assets/img/svg/scanner.svg"
import moment from 'moment';
import { getAllOnlineVendor } from '../../dropdowns';
import { useGetCollectPaymentContext } from '../../../context';
import Error from '../../errorHandlimg/Error';
import { eftValidation } from '../../validations/paymentModeValidation';
import { getConditionalCOllectSaveButton } from '../../components/common';

const EFTModeView =({ isEditForm,isReceiptEdit=false, isView=false,contextValue,rowId,handleClose}) =>{
    const [errorMgs, setErrorMgs] = useState()

    const {
        bankDropdown,
        paymentModeFormHandler,
        studentBasicDetails, 
        currentPaymentMode,
        paymentModeForm,
        selectedChargesAmount,
        bankMasterId,
        setBalanceAmount,
        setBalanceMode,
        setloader,
        setCollectPayment,
        collectPayment,
        balanceAmount,
        setModifyPaymentModeData,
        validatePaymentMode,
        disableAmountField
    } = contextValue;

    const validatePayment=async()=>{
        const error=await eftValidation(paymentModeForm,collectPayment,balanceAmount)
        setErrorMgs(error)
       if(!error)
        {
           const isOk= await validatePaymentMode(studentBasicDetails, currentPaymentMode, paymentModeForm, selectedChargesAmount, bankMasterId, '', setBalanceAmount, setBalanceMode, setloader, setCollectPayment, balanceAmount, collectPayment);
           if(isOk){
            isReceiptEdit===true &&setModifyPaymentModeData((prev) => ({ ...prev, [rowId]: paymentModeForm }))
            isReceiptEdit&&handleClose(true)
           }

        }   
    }
const disabled=!(paymentModeForm?.referenceNumber && paymentModeForm?.paidAmount && paymentModeForm?.paymentModeDate && paymentModeForm?.bank)

    return(
        <>
        {!isView&&!isReceiptEdit&&<div className=" d-flex justify-content-between align-items-center mt-2">
                <span className="large-bold color-dark">Electronic Fund Transfer (EFT)</span>
        </div>}
        <Row>
        <Col md="4">
            <div>
                <AInput
                    label="Transaction ID*"
                    labelStyle={labelSyle}
                    value={paymentModeForm?.referenceNumber}
                    handler={(value) => {paymentModeFormHandler("referenceNumber",value) }}
                    placeholder="Enter"
                    style={{ height: "47px", width: '265px', borderRadius: "5px" }}
                    disabled={isView}
                    maxLength={30}
                />
            </div>
        </Col>
        <Col md="4">
            <div>
                <AInput
                    label="Transaction Amount*"
                    labelStyle={labelSyle}
                    value={paymentModeForm?.paidAmount}
                    handler={(value) => {
                        if (
                            !value || parseFloat(value) > 0
                        ) {
                            paymentModeFormHandler('paidAmount',value)
                        }

                    }}
                    customIcon={
                        <div className='large-semi-bold'>&#8377;</div>
                      }
                      customIconStyle={customStyle}
                    placeholder="Enter amount"
                    style={inputAmountStyle}
                    disabled={isView||isReceiptEdit===true || disableAmountField}
                    regex={numberDecimalLimitRegex(10, 2)}
                />
            </div>
        </Col>
        <Col md="4">
                    <div style={{ width: '265px' }}>
                        <CustomDatePickerV2
                            label="Transaction date*"
                            labelStyle={labelSyle}
                            style={{ input: { minHeight: "47px" } }}
                            placeHolder="Select"
                            value={paymentModeForm?.paymentModeDate}
                            handler={(index, date) => {paymentModeFormHandler("paymentModeDate",date )}}
                            isStartDate={true}
                            minDate={studentBasicDetails?.detailsMap?.termStartDate}
                            maxDate={new moment(new Date())}
                            disabled={isView}
                        />
                    </div>
                </Col>
        </Row>
        <Row>
        <Col md="4">
                    <div>
                        <AAutoComplete
                            label="Bank ID*"
                            labelStyle={labelSyle}
                            placeholder="Select Bank"
                            currentValue={paymentModeForm?.bank}
                            handleChange={(value) => {paymentModeFormHandler("bank",value) }}
                            items={getSwapLabelValue(bankDropdown)}
                            isMulti={false}
                            isShowCount={false}
                            style={{ control: { height: "47px", width: '265px', borderRadius: "5px" } }}
                            isDisabled={isView}
                        />
                    </div>
                </Col>
                <Col md="4">
                <div>
                <AInput
                    label="Bank Name"
                    labelStyle={labelSyle}
                    value={paymentModeForm?.bank?.value}
                    placeholder="Enter"
                    disabled={true}
                    style={{ height: "47px", width: '265px', borderRadius: "5px" }}
                />
                </div>
                </Col>
                <Col md="4">
            <div>
            <AInput
                    label="Gateway Name"
                    labelStyle={labelSyle}
                    value={paymentModeForm?.gatewayName}
                    handler={(value) => {paymentModeFormHandler("gatewayName",value) }}
                    placeholder="Enter"
                    style={{ height: "47px", width: '265px', borderRadius: "5px" }}
                    disabled={isView}
                />
            </div>
        </Col>
        </Row>
        {getConditionalCOllectSaveButton(disabled,
                paymentModeForm,
                validatePayment,
                isReceiptEdit,
                isEditForm,
                isView,
                setModifyPaymentModeData,
                rowId,
                handleClose)}
        
        <Error errorMgs={errorMgs}/>
        </>
        
    )
}
export default EFTModeView